import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import onError from '../../../utils/onError';
import { Tax } from '@chegg/commerce-utils';
import { TaxWrapper } from '../styled';
import { TAX_WRAPPER } from '../constants';
var TaxDetails = function TaxDetails(_ref) {
  var isReviewStep = _ref.isReviewStep,
    price = _ref.price,
    basePrice = _ref.basePrice,
    isDiscounted = _ref.isDiscounted,
    reviewStepEnabled = _ref.reviewStepEnabled,
    tax = _ref.tax;
  if (reviewStepEnabled && isReviewStep || !tax) return null;
  return /*#__PURE__*/React.createElement(TaxWrapper, {
    "data-test": TAX_WRAPPER
  }, /*#__PURE__*/React.createElement(Tax, _extends({
    price: price,
    content: tax,
    onError: onError
  }, isDiscounted && {
    basePrice: basePrice,
    discountedTaxInfo: tax.discountedTaxInfo
  })));
};
export default TaxDetails;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/CartCheckout/internals/TaxDetails.js
// module id = 1464
// module chunks = 11